/* ========================================
   BK-MEDIA CUSTOM JAVASCRIPT
   ======================================== */

/* ========================================
   FREE SHIPPING BAR DISCOUNT FIX
   ======================================== */

(function() {
  'use strict';

  function calculateDiscountedTotal(cart) {
    const items = cart["items"] || [];
    const discountApplications = cart["cart_level_discount_applications"] || [];
    
    // Calculate total price for items that require shipping
    // Use final_line_price which already includes line-level discounts
    let priceForItems = 0;
    for (const item of items) {
      if (item["requires_shipping"] === true) {
        const linePrice = parseFloat(item["final_line_price"]);
        if (!isNaN(linePrice) && linePrice > 0) {
          priceForItems += linePrice;
        }
      }
    }
    
    // Calculate total cart-level discounts
    let cartDiscount = 0;
    for (const discount of discountApplications) {
      const discountAmount = parseFloat(discount["total_allocated_amount"]);
      if (!isNaN(discountAmount) && discountAmount > 0) {
        cartDiscount += discountAmount;
      }
    }
    
    // Calculate final total (items total minus cart-level discounts)
    const calculatedTotal = priceForItems - cartDiscount;
    
    // Ensure we have a valid number (at least 0)
    return isNaN(calculatedTotal) || calculatedTotal < 0 ? 0 : calculatedTotal;
  }

  function updateFreeShippingBars(cart) {
    const freeShippingBars = document.querySelectorAll('free-shipping-bar');
    const discountedTotal = calculateDiscountedTotal(cart);
    
    freeShippingBars.forEach(bar => {
      // Update the total-price attribute, which will trigger attributeChangedCallback
      const currentTotal = parseFloat(bar.getAttribute('total-price'));
      if (isNaN(currentTotal) || currentTotal !== discountedTotal) {
        bar.setAttribute('total-price', discountedTotal);
      }
    });
  }

  // Listen for cart:change events and update free shipping bars
  document.addEventListener('cart:change', function(event) {
    const cart = event.detail && event.detail["cart"];
    if (cart) {
      updateFreeShippingBars(cart);
    }
  });

  // Initialize on page load
  function init() {
    // Wait a bit for custom elements to be defined
    setTimeout(function() {
      const freeShippingBars = document.querySelectorAll('free-shipping-bar');
      if (freeShippingBars.length > 0) {
        // Enhance the _onCartChanged method on the prototype
        const FreeShippingBarElement = window.customElements.get('free-shipping-bar');
        if (FreeShippingBarElement && FreeShippingBarElement.prototype) {
          const originalOnCartChanged = FreeShippingBarElement.prototype._onCartChanged;
          
          if (originalOnCartChanged) {
            FreeShippingBarElement.prototype._onCartChanged = function(event) {
              const cart = event.detail["cart"] || {};
              const discountedTotal = calculateDiscountedTotal(cart);
              this.totalPrice = discountedTotal;
            };
          }
        }
      }
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

